import { useQuery } from '@tanstack/react-query';
import useApi from 'hooks/useApi';
import factionsFactory from 'utils/factories/factions';

export const useFactions = () => {
  const api = useApi();

  return useQuery({
    queryKey: factionsFactory.list(),
    queryFn: () => api.factions.apiFactionsGetCollection({ 'order[reference]': 'asc' }),
    // @ts-expect-error NE not type correctly
    select: (v) => v.data?.['hydra:member'].filter((f) => f.reference !== 'NE'),
  });
};
